module.exports = __webpack_public_path__ + "img/home_btn.4958fce6.png";